import React from 'react';
import { PUBLIC_SITE_NAME, SIGNED_IN_PRODUCT_NAME, LOGO_URL } from '../config/brand';

export const BrandMark = ({ size = 32, light = false }) => (
  LOGO_URL ? (
    <img src={LOGO_URL} alt="" width={size} height={size} className="object-contain shrink-0" style={{ width: size, height: size }} data-testid="brand-mark-image" />
  ) : (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
      <rect width="32" height="32" rx="9" fill={light ? '#FFFFFF' : '#0A1551'} />
      <path d="M21.5 11.2A7 7 0 1 0 21.5 20.8" stroke={light ? '#0A1551' : '#FFFFFF'} strokeWidth="3.2" strokeLinecap="round" fill="none" />
      <circle cx="22.5" cy="16" r="2.2" fill="#0F766E" />
    </svg>
  )
);

export const BrandLogo = ({ variant = 'product', size = 'md', light = false }) => {
  const name = variant === 'public' ? PUBLIC_SITE_NAME : SIGNED_IN_PRODUCT_NAME;
  const text = size === 'sm' ? 'text-[17px]' : 'text-[21px]';
  return (
    <div className="flex items-center gap-2 shrink-0" data-testid={`brand-logo-${variant}`}>
      <BrandMark size={size === 'sm' ? 26 : 32} light={light} />
      <span className={`font-bold ${text} tracking-tight ${light ? 'text-white' : 'text-[#0A1551]'}`}>{name}</span>
    </div>
  );
};

export const AssistantOrb = ({ size = 28 }) => (
  <div className="relative rounded-full shrink-0" style={{ width: size, height: size, background: 'radial-gradient(circle at 30% 30%, #5EEAD4 0%, #0F766E 55%, #0A1551 100%)' }} aria-hidden="true">
    <div className="absolute rounded-full bg-white/80" style={{ width: size * 0.22, height: size * 0.22, top: size * 0.24, left: size * 0.26 }} />
  </div>
);
